import EquipmentTemplateRule from './EquipmentTemplateRule'
import Employee from './Employee'
export class SaveEquipmentTemplateRuleRequest {
    EquipmentTemplateRule: EquipmentTemplateRule;
    SavedByEmployee: Employee;
}

export default SaveEquipmentTemplateRuleRequest;